// extracted by mini-css-extract-plugin
module.exports = {"input":"search_input__kkOU8","label":"search_label__8N3wi","btn__icon":"search_btn__icon__FhwVw"};